(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/route-result/assets/javascripts/result-layout.js') >= 0) return;  svs.modules.push('/components/tipsen/route-result/assets/javascripts/result-layout.js');
"use strict";

const {
  CalendarHolder,
  TableHolder,
  ResultDistribution,
  ResultDistributionFallback,
  ResultCoupon,
  useFetchDate,
  useSelectedResultDraw,
  ResultSportkryss,
  ResultNoDrawsAvailableFallback,
  useCurrentDateDraws
} = svs.components.tipsen.routeResult;
const {
  useDraw,
  useDrawSubscription
} = svs.components.sport.drawsRedux.hooks;
const {
  useDrawResults
} = svs.components.tipsen.hooks;
const {
  selectSportkryssFactors
} = svs.components.tipsen.engine.selectors.engineSelectors;
const {
  ErrorBoundary
} = svs.components.errorBoundary;
const {
  useSelector
} = ReactRedux;
const {
  WidgetContainer
} = svs.components.poolBetting.drawWidgets;
const {
  DetailViewRouteResultHandler
} = svs.components.tipsen.detailViewRouteResultHandler;
const {
  TemplateBrand
} = svs.components.tipsen.setBranding;
const {
  TipsenModuleGameUrl
} = svs.components.sport.tipsenShared;
const {
  ReactPaper: Paper
} = svs.ui;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_MD
} = svs.components.lbUtils.useMediaQuery;
const {
  CenterToScreen
} = svs.components.tipsen.centerToScreen;
const {
  useDrawErrorHandling
} = svs.components.tipsen.hooksWager.useDrawErrorHandling;
const {
  useDefinition
} = svs.components.tipsen.engine.utils;
const SportKryssErrorFallback = () => React.createElement("span", null, "N\xE5got gick fel. Vi kan inte visa resultat f\xF6r Sportkryss just nu.");
const ResultLayout = () => {
  var _drawResults$1$, _currentDateDraws$;
  const [{
    year,
    month
  }, currentDate, hasDateParam, noDrawsDateAvailable] = useFetchDate();
  const [currentDateDraws, isLoadingFetchDate] = useCurrentDateDraws(year, month, currentDate, hasDateParam);
  const [drawNumber, productId] = useSelectedResultDraw(currentDateDraws);

  useDrawSubscription(drawNumber, productId, {
    sendInitialUpdate: true
  });
  const definition = useDefinition();
  const shouldFetchJackpot = (definition === null || definition === void 0 ? void 0 : definition.hasJackpot) || false;
  const draw = useDraw({
    productId,
    drawNumber
  }, {
    shouldFetchJackpot
  });
  const {
    data: drawResults
  } = useDrawResults({
    productId,
    drawNumber
  });
  const drawId = "".concat(productId, "_").concat(drawNumber);
  const isWideScreen = useMediaQuery(breakpoints.up(BREAKPOINT_MD));
  const errorDialog = {
    acceptText: 'Okej'
  };
  useDrawErrorHandling({
    drawNumber,
    productId,
    errorDialog,
    shouldRedirect: false
  });

  const sportkryssFactors = useSelector(selectSportkryssFactors);
  const shouldRenderSportkrysset = sportkryssFactors && (sportkryssFactors === null || sportkryssFactors === void 0 ? void 0 : sportkryssFactors.length) > 1;
  const [,,, drawIsCancelled] = drawResults;
  const resultDistributionLoading = !drawNumber && !productId;
  const shouldRenderResultDistribution = !drawIsCancelled && drawResults && drawResults[1] && drawResults[1][0] && ((_drawResults$1$ = drawResults[1][0]) === null || _drawResults$1$ === void 0 ? void 0 : _drawResults$1$.winDiv);
  return React.createElement(CenterToScreen, {
    className: "result-layout",
    isMainElem: true
  }, draw && React.createElement(TemplateBrand, {
    draw: draw,
    drawId: drawId
  }), React.createElement("div", {
    className: "calendar-holder"
  }, React.createElement(CalendarHolder, null)), noDrawsDateAvailable && !((_currentDateDraws$ = currentDateDraws[0]) !== null && _currentDateDraws$ !== void 0 && _currentDateDraws$.drawNumber) ? React.createElement(ResultNoDrawsAvailableFallback, null) : React.createElement("div", {
    className: "grid-row"
  }, React.createElement("div", {
    className: "col-md-".concat(isWideScreen ? 7 : 12)
  }, React.createElement(ResultCoupon, {
    currentDateDraws: currentDateDraws,
    draw: draw,
    drawResults: drawResults,
    isLoadingFetchDate: isLoadingFetchDate
  }), (resultDistributionLoading || shouldRenderResultDistribution) && React.createElement(TableHolder, {
    label: "Utdelning"
  }, React.createElement(Paper, {
    branding: "sport"
  }, shouldRenderResultDistribution ? React.createElement(ResultDistribution, {
    drawNumber: drawNumber,
    productId: productId
  }) : React.createElement(ResultDistributionFallback, null))), shouldRenderSportkrysset && React.createElement(ErrorBoundary, {
    fallback: SportKryssErrorFallback
  }, React.createElement(ResultSportkryss, {
    currentDateDraw: currentDateDraws[0],
    month: month,
    sportkryssFactors: sportkryssFactors,
    year: year
  })), React.createElement(WidgetContainer, {
    className: isWideScreen ? 'margin-right-half margin-left-1' : 'margin-right-1 margin-left-1',
    drawNumber: draw === null || draw === void 0 ? void 0 : draw.drawNumber,
    productId: draw === null || draw === void 0 ? void 0 : draw.productId
  })), draw && React.createElement("aside", {
    "aria-label": "Statistik",
    className: "pg_sticky_div__statistics col-md-5"
  }, React.createElement(DetailViewRouteResultHandler, {
    drawNumber: draw.drawNumber,
    menuItemPathsPrefix: "".concat(TipsenModuleGameUrl.RESULT, "/:date([0-9]{4}-[0-9]{2}-[0-9]{2})?"),
    productId: draw.productId
  }))));
};
setGlobal('svs.components.tipsen.routeResult.ResultLayout', ResultLayout);

 })(window);